export default __webpack_public_path__ + "static/media/login-bg.862f816d.png";